import React from 'react'

function About() {
  return (
    <div>
      hii bheemrj2
    </div>
  )
}

export default About
